import { z } from "zod";
import { ZDateish, ZObjectIdString, ZProjectNo } from "../foundationSchema";
import { ZUserRef } from "../user.schema";
import { ZViewerView } from "../viewerView.schema";
import { ZViewSnapshotContext } from "../viewSnapshotContext.schema";
export const VIEWS_COLLECTION_NAME = "views";
/** Scope is metadata; API authorization must enforce who may read or edit a preset. */
export const ZViewPresetScope = z.enum(["personal", "project"]);
const ZViewMongoDocumentBase = z.object({
    _id: ZObjectIdString.optional(),
    projectNo: ZProjectNo,
    createdAt: ZDateish,
    createdBy: ZUserRef,
    view: ZViewerView,
});
/** Editable saved view. Personal presets belong to createdBy._id in this project. */
export const ZViewPresetMongoDocument = ZViewMongoDocumentBase.extend({
    kind: z.literal("preset"),
    name: z.string().trim().min(1).max(100),
    description: z.string().max(500).optional(),
    source: z.literal("user"),
    scope: ZViewPresetScope,
    updatedAt: ZDateish.optional(),
});
/** Immutable shared-link snapshot; independent of any editable preset.
 * Project access must still be enforced by the API.
 */
export const ZViewSnapshotMongoDocument = ZViewMongoDocumentBase.extend({
    kind: z.literal("snapshot"),
    context: ZViewSnapshotContext,
});
export const ZViewMongoDocument = z.discriminatedUnion("kind", [
    ZViewPresetMongoDocument,
    ZViewSnapshotMongoDocument,
]);
